/* Reconcile rows: speech changes don't recreate images or restart avatar downloads. */
export function createVoiceOverlayRenderer(panel) {
const rows = new Map()
const container = panel.querySelector('#participants')
const paths = {
  muted: '<path d="m3 3 18 18M9 9v3a3 3 0 0 0 5 2M9 5a3 3 0 0 1 6 0v5M5 10v2a7 7 0 0 0 12 5M19 10v2M12 19v3m-3 0h6"/>',
  deafened: '<path d="m3 3 18 18M4 14v-2a8 8 0 0 1 1-4M8 5a8 8 0 0 1 12 7v6M4 13h3v7H4zM17 13h3v7h-3z"/>',
  stream: '<rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/><path d="m10 7 5 3-5 3z"/>',
}
const svg = (kind) => `<svg viewBox="0 0 24 24">${paths[kind]}</svg>`
function render(state, prefs) {
  panel.style.opacity = (prefs.overlayOpacity ?? 85) / 100
  panel.dataset.corner = prefs.overlayCorner ?? 'top-left'
  const size = { small: 24, medium: 32, large: 40 }[prefs.overlayAvatarSize] ?? 32
  panel.style.setProperty('--avatar-size', `${size}px`)
  panel.style.setProperty('--row-height', `${Math.max(28, prefs.overlayAvatars === false ? 24 : size) + 8}px`)
  const channel = panel.querySelector('#channel')
  channel.textContent = state.status === 'connected' ? state.channel : state.status === 'connecting' ? 'Подключение…' : 'Переподключение…'
  channel.hidden = !prefs.overlayChannel && state.status === 'connected'
  const visible = state.participants.filter(p => prefs.overlayUsers !== 'talking' || p.speaking)
  const people = visible.slice(0, prefs.overlayMaxUsers ?? 6)
  const ids = new Set(people.map(p => p.id))
  for (const [id, row] of rows) if (!ids.has(id)) { row.el.remove(); rows.delete(id) }
  for (const p of people) {
    let row = rows.get(p.id)
    if (!row) {
      const el = document.createElement('div'); el.className = 'person'
      const avatar = document.createElement('div'); avatar.className = 'avatar'
      const initial = document.createElement('span'); avatar.append(initial)
      const pill = document.createElement('div'); pill.className = 'pill'
      const name = document.createElement('span'); name.className = 'name'
      const tag = document.createElement('span'); tag.className = 'tag'; pill.append(name, tag)
      const icons = document.createElement('div'); icons.className = 'icons'
      const stream = document.createElement('span'); stream.className = 'icon stream'; stream.innerHTML = svg('stream'); stream.setAttribute('aria-label', 'Транслирует экран')
      const icon = document.createElement('span'); icon.className = 'icon'; icons.append(stream, icon)
      el.append(avatar, pill, icons)
      row = { el, avatar, initial, pill, name, tag, stream, icon, src: null }; rows.set(p.id, row)
    }
    row.el.classList.toggle('speaking', p.speaking === true)
    row.name.textContent = p.name
    row.pill.hidden = prefs.overlayNames === 'never' || (prefs.overlayNames === 'talking' && !p.speaking)
    row.avatar.hidden = prefs.overlayAvatars === false
    row.tag.hidden = prefs.overlayTags === false || !p.tag
    row.tag.textContent = p.tag ?? ''
    row.tag.style.setProperty('--tag-color', Number.isInteger(p.tagColor) && p.tagColor >= 0 && p.tagColor <= 0xffffff ? '#' + p.tagColor.toString(16).padStart(6, '0') : '#5865f2')
    row.stream.hidden = prefs.overlayStreaming === false || !p.streaming
    row.initial.textContent = Array.from(p.name)[0]?.toUpperCase() ?? '?'
    if (row.src !== p.avatar) {
      row.avatar.querySelector('img')?.remove()
      row.src = p.avatar
      if (p.avatar) {
        const img = document.createElement('img'); img.alt = ''; img.referrerPolicy = 'no-referrer'; img.src = p.avatar
        img.addEventListener('error', () => img.remove(), { once: true }); row.avatar.append(img)
      }
    }
    const kind = p.deafened ? 'deafened' : p.muted ? 'muted' : ''
    // SVG markup is constant; all user-provided content uses textContent.
    if (row.icon.dataset.kind !== kind) {
      row.icon.dataset.kind = kind
      row.icon.innerHTML = kind ? svg(kind) : ''
      row.icon.setAttribute('aria-label', p.deafened ? 'Звук выключен' : p.muted ? 'Микрофон выключен' : '')
    }
    row.icon.hidden = !kind
    container.append(row.el)
  }
  const more = panel.querySelector('#more')
  const total = state.total ?? visible.length
  more.hidden = total <= people.length
  more.textContent = `Ещё ${total - people.length}`
}
return render
}
